import { HttpRequestStatus } from '@cpm-pr1618003/ng-initializer-lib';
import { Action, createFeature, createReducer, on } from '@ngrx/store';
import * as settingsActions from '../actions/settings.actions';
import { SettingsState, initialSettingsState } from '../state/settings.state';

export const settingsFeatureStoreKey: string = 'settingsState';

export const reducers = (
  state: SettingsState,
  action: Action,
): SettingsState => {
  return initReducer(state, action);
};

export const initReducer = createReducer(
  initialSettingsState,
  on(settingsActions.loadSettingsTabsSuccess, (state, { tabs }) => ({
    ...state,
    settingsTabs: tabs,
  })),
  on(settingsActions.updateProfileInfo, (state) => ({
    ...state,
    updateProfileInfoStatus: HttpRequestStatus.In_progress,
  })),
  on(settingsActions.updateProfileInfoSuccess, (state) => ({
    ...state,
    updateProfileInfoStatus: HttpRequestStatus.Success,
  })),
  on(settingsActions.updateProfileInfoError, (state) => ({
    ...state,
    updateProfileInfoStatus: HttpRequestStatus.Failed,
  })),
  on(settingsActions.resetUpdateProfileInfoStatus, (state) => ({
    ...state,
    updateProfileInfoStatus: HttpRequestStatus.Idle,
  })),
  on(settingsActions.sendDeleteVerificationCode, (state) => ({
    ...state,
    sendDeleteVerificationCodeStatus: HttpRequestStatus.In_progress,
  })),
  on(settingsActions.sendDeleteVerificationCodeSuccess, (state) => ({
    ...state,
    sendDeleteVerificationCodeStatus: HttpRequestStatus.Success,
  })),
  on(settingsActions.sendDeleteVerificationCodeError, (state) => ({
    ...state,
    sendDeleteVerificationCodeStatus: HttpRequestStatus.Failed,
  })),
  on(settingsActions.resetSendDeleteVerificationCodeStatus, (state) => ({
    ...state,
    sendDeleteVerificationCodeStatus: HttpRequestStatus.Idle,
  })),
  on(settingsActions.deleteAccount, (state) => ({
    ...state,
    deleteAccountStatus: HttpRequestStatus.In_progress,
    deleteAccountErrorMessage: null,
  })),
  on(settingsActions.deleteAccountSuccess, (state) => ({
    ...state,
    deleteAccountStatus: HttpRequestStatus.Success,
    deleteAccountErrorMessage: null,
  })),
  on(settingsActions.deleteAccountError, (state, { errorMessage }) => ({
    ...state,
    deleteAccountStatus: HttpRequestStatus.Failed,
    deleteAccountErrorMessage: errorMessage ?? 'Failed to delete account.',
  })),
  on(settingsActions.resetDeleteAccountStatus, (state) => ({
    ...state,
    deleteAccountStatus: HttpRequestStatus.Idle,
    deleteAccountErrorMessage: null,
  })),
  on(settingsActions.resetDeleteAccountModalState, (state) => ({
    ...state,
    sendDeleteVerificationCodeStatus: HttpRequestStatus.Idle,
    deleteAccountStatus: HttpRequestStatus.Idle,
    deleteAccountErrorMessage: null,
  })),
);

export const settingsFeature = createFeature({
  name: settingsFeatureStoreKey,
  reducer: reducers,
});
